import { Stack } from "react-bootstrap";

const OrderSkeleton = () => {
  return (
    <div className="order-cart-item p-3 rounded shadow-sm mb-3" style={{ 
      backgroundColor: '#fff',
      border: '1px solid #f0f0f0'
    }}>
      <Stack
        direction="horizontal"
        gap={3}
        className="d-flex align-items-center"
      >
        <div 
          className="skeleton-image" 
          style={{
            width: '105px',
            height: '75px',
            borderRadius: '8px',
            backgroundColor: '#e9ecef',
            animation: 'pulse 1.5s infinite'
          }}
        />

        <div className="me-auto">
          <div 
            className="skeleton-title" 
            style={{
              width: '150px',
              height: '20px',
              backgroundColor: '#e9ecef',
              borderRadius: '4px',
              marginBottom: '8px',
              animation: 'pulse 1.5s infinite'
            }}
          />
          <div 
            className="skeleton-text" 
            style={{
              width: '200px',
              height: '16px',
              backgroundColor: '#e9ecef',
              borderRadius: '4px',
              animation: 'pulse 1.5s infinite'
            }}
          />
        </div>
      </Stack>

      <style>
        {`
          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OrderSkeleton;
